
let button = {
    add: '添 加',
    del: '删 除',
    confirm: '确 定',
    cancle: '取 消',
    yes: '是',
    no: '否',
    positionReport: '持仓',
    tradingHistory: '交易历史',
    startDate: '开始日期',
    to: '至',
    endDate: '结束日期',
    latelyWeek: '最近一周',
    latelyMonth: '最近一个月',
    latelyThreeMonth: '最近三个月',
    auth: '权限分配',
    edit: '修 改',
    disabled: '禁用',
    undisabled: '解禁',
    affirm: '确 认',
    refuse: '拒 绝'

}

export default button;




































// WEBPACK FOOTER //
// ./src/i18n/chinese/button.js